// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"ed77bedc4088e3ef","983":"3a1552a25af5e0e9"}[chunkId] + ".js";
};